module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentMerchant && _vm.user) ? _c('div', {
    staticClass: "c-navbar__right"
  }, [_c('drop', {
    staticClass: "c-navbar__item"
  }, [_c('a', {
    staticClass: "c-account",
    attrs: {
      "slot": "trigger",
      "role": "button"
    },
    slot: "trigger"
  }, [_c('div', {
    staticClass: "c-account__media"
  }, [_vm._v("\n        " + _vm._s(_vm.currentMerchant.name) + " (" + _vm._s(_vm.user.email) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-account__after"
  }, [_c('i', {
    staticClass: "i-caret i-caret--light"
  })])]), _vm._v(" "), _c('drop-content', {
    attrs: {
      "slot": "content",
      "placement": "bottom-end"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "c-nav c-nav--menus"
  }, [_vm._l((_vm.merchants), function(merchant) {
    return _c('li', {
      staticClass: "c-nav__item"
    }, [_c('a', {
      staticClass: "c-nav__link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.changeMerchant(merchant.identifier)
        }
      }
    }, [_vm._v(_vm._s(merchant.name))])])
  }), _vm._v(" "), (_vm.hasMoreAccounts) ? _c('li', {
    staticClass: "c-nav__item"
  }, [_c('a', {
    staticClass: "c-nav__link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Outras contas")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "c-nav__divider"
  }), _vm._v(" "), _c('li', {
    staticClass: "c-nav__item"
  }, [_c('a', {
    staticClass: "c-nav__link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('logout.label')))])])], 2)])], 1), _vm._v(" "), _c('modal-accounts', {
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f072760","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/MenuTopBar.vue
// module id = 2908
// module chunks = 0